import React from "react";
import { AiTwotoneHome } from "react-icons/ai";
import { FaUserAlt } from "react-icons/fa";
import { FaHome } from "react-icons/fa";
import { BiSolidMessageDetail } from "react-icons/bi";
import { BiSolidWidget } from "react-icons/bi";
import { FaAward } from "react-icons/fa";
import { BiAward } from "react-icons/bi";
const Headeer = () => {
  return (
    <div className=" fixed bottom-2 lg:bottom-8 w-full overflow-hidden z-50">
      <div className=" container left-[10%] mx-auto ">
        <div className=" md:hidden flex flex-row bg-black/20  backdrop-blur-2xl justify-between items-center rounded-full max-w-[460px] mx-auto  w=full h-[50px] px-5 text-2xl">
          <div classname=" w-[60px] h-[60px] flex items-center justify-center">
            <a
              href="#"
              className="cursor-pointer"
              activeClass="active"
              smooth={true}
              spy={true}
            >
              <FaHome color="black" />
            </a>
          </div>
          <div>
            <a
              href="#About"
              className="cursor-pointer"
              activeClass="active"
              smooth={true}
              spy={true}
            >
              <FaUserAlt color="black" />
            </a>
          </div>
          <div>
            <a
              href="#Skill"
              className="cursor-pointer"
              activeClass="active"
              smooth={true}
              spy={true}
            >
              <FaAward color="black" />
            </a>
          </div>
          <div>
            <a
              href="#Projects"
              className="cursor-pointer"
              activeClass="active"
              smooth={true}
              spy={true}
            >
              <BiSolidWidget color="black" />
            </a>
          </div>
          <div>
            <a
              href="#ContactMe"
              className="cursor-pointer  "
              activeClass="active"
              smooth={true}
              spy={true}
            >
              <BiSolidMessageDetail color="black" />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Headeer;
